import { Component, OnInit } from '@angular/core';
import * as Sentry from '@sentry/angular';
import { AuthlessLandingpageService } from '../services/authless-landingpage.service';

@Component({
    selector: 'app-unauthorized',
    templateUrl: './unauthorized.component.html',
    styleUrls: ['./unauthorized.component.scss'],
    standalone: false
})
export class UnauthorizedComponent implements OnInit {

  error = '';

  constructor(private authlessLandingpageService: AuthlessLandingpageService) { }

  ngOnInit(): void {

    this.authlessLandingpageService.getServerInfo().subscribe({
      next: (serverInfo) => {

          
        document.querySelectorAll<HTMLElement>('.efs-global-spinner')[0].style.visibility = 'hidden';


        const timeOffset = Date.now() - serverInfo.timestamp;

        console.log('Time offset: ', timeOffset);

        if (timeOffset > 1000 * 60) {
          // Client Server Time Difference is more than 1 minute
          this.error = 'time-offset-error';
          Sentry.captureException(new Error(`Time offset is more than 2 minute, ${timeOffset}ms Server: ${serverInfo.timestamp}, Client-Time: ${Date.now()}`));
        }
      },
      error: (error) => {
        console.error('Error getting server info: ', error);
        this.error = 'server-info-error';
        document.querySelectorAll<HTMLElement>('.efs-global-spinner')[0].style.visibility = 'hidden';
      }
    });
  }

  reloadPage() {
    window.location.href = 'https://start.efs-ag.com';
  }
}
